var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9454 20.4316L3.31782 12.804C3.20225 12.6884 3.12019 12.5632 3.07165 12.4284C3.02388 12.2935 3 12.1491 3 11.995C3 11.8409 3.02388 11.6964 3.07165 11.5616C3.12019 11.4268 3.20225 11.3016 3.31782 11.186L10.9454 3.55838C11.1573 3.3465 11.422 3.23556 11.7394 3.22554C12.0576 3.21629 12.3323 3.32724 12.5634 3.55838C12.7945 3.77026 12.9151 4.03491 12.9251 4.35234C12.9344 4.67055 12.8234 4.94522 12.5923 5.17636L6.92937 10.8393H19.8443C20.1717 10.8393 20.4464 10.9498 20.6683 11.171C20.8894 11.3929 21 11.6675 21 11.995C21 12.3224 20.8894 12.5967 20.6683 12.8178C20.4464 13.0397 20.1717 13.1507 19.8443 13.1507H6.92937L12.5923 18.8136C12.8042 19.0255 12.9151 19.2951 12.9251 19.6226C12.9344 19.95 12.8234 20.2197 12.5923 20.4316C12.3804 20.6627 12.1108 20.7783 11.7833 20.7783C11.4559 20.7783 11.1766 20.6627 10.9454 20.4316Z",
    fill: "#1C1D24"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBack);
export default __webpack_public_path__ + "static/media/ic_back.2524613c28b816702cb38785a1bd1223.svg";
export { ForwardRef as ReactComponent };